import usePrivateAxios from "@/common/api/usePrivateAxios";
import { Mapper } from "@/common/services/mapper";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseGeoOptionsByTypeProps<T> = {
  filters?: {
    type?: string;
    search?: string;
  };
  mapper?: (data: any) => T;
};

export const useGeoOptionsByType = <T,>({
  filters: { type, search = '' } = {},
  mapper = Mapper.default<T>(),
}: UseGeoOptionsByTypeProps<T>) => {
  const privateAxios = usePrivateAxios();

  const fallbackData = mapper([] as any);

  const query = useQuery({
    queryKey: ['geoOptionsByType', type, search],
    enabled: Boolean(type),
    queryFn: () => privateAxios.get(`/geo/${type}`, {
      params: {
        search,
      },
    }),
    select: (response: { data: { data: any[]; }; }) => mapper(response?.data?.data ?? []),
    placeholderData: keepPreviousData,
  });

  return {
    ...query,
    data: query.data ?? fallbackData,
  };
};
